const UserActions = {
  SET_CURRENT_USER: "SET_CURRENT_USER",
  USER_REGISTER_START: "USER_REGISTER_START",
  USER_REGISTER_SUCCESS: "USER_REGISTER_SUCCESS",
  USER_REGISTER_FAILURE: "USER_REGISTER_FAILURE",
  VERIFY_EMAIL_START: "VERIFY_EMAIL_START",
  VERIFY_EMAIL_SUCCESS: "VERIFY_EMAIL_SUCCESS",
  VERIFY_EMAIL_FAILURE: "VERIFY_EMAIL_FAILURE",
  RESEND_VERIFICATION_START: "RESEND_VERIFICATION_START",
  RESEND_VERIFICATION_SUCCESS: "RESEND_VERIFICATION_SUCCESS",
  RESEND_VERIFICATION_FAILURE: "RESEND_VERIFICATION_FAILURE",
  USER_LOGIN_START: "USER_LOGIN_START",
  USER_LOGIN_SUCCESS: "USER_LOGIN_SUCCESS",
  USER_LOGIN_FAILURE: "USER_LOGIN_FAILURE",
  USER_RESET_PASSWORD_START: "USER_RESET_PASSWORD_START",
  USER_RESET_PASSWORD_SUCCESS: "USER_RESET_PASSWORD_SUCCESS",
  USER_RESET_PASSWORD_FAILURE: "USER_RESET_PASSWORD_FAILURE",
  USER_SEND_NEW_PASSWORD_START: "USER_SEND_NEW_PASSWORD_START",
  USER_SEND_NEW_PASSWORD_SUCCESS: "USER_SEND_NEW_PASSWORD_SUCCESS",
  USER_SEND_NEW_PASSWORD_FAILURE: "USER_SEND_NEW_PASSWORD_FAILURE",
  USER_LOG_OUT_START: "USER_LOG_OUT_START",
  USER_LOG_OUT_SUCCESS: "USER_LOG_OUT_SUCCESS",
  USER_LOG_OUT_FAILURE: "USER_LOG_OUT_FAILURE",
  ADD_STAFF_START: "ADD_STAFF_START",
  ADD_STAFF_SUCCESS: "ADD_STAFF_SUCCESS",
  ADD_STAFF_FAILURE: "ADD_STAFF_FAILURE",
  EDIT_STAFF_START: "EDIT_STAFF_START",
  EDIT_STAFF_SUCCESS: "EDIT_STAFF_SUCCESS",
  EDIT_STAFF_FAILURE: "EDIT_STAFF_FAILURE",
  DELETE_STAFF_START: "DELETE_STAFF_START",
  DELETE_STAFF_SUCCESS: "DELETE_STAFF_SUCCESS",
  DELETE_STAFF_FAILURE: "DELETE_STAFF_FAILURE",
  SEARCH_STAFF_START: "SEARCH_STAFF_START",
  SEARCH_STAFF_SUCCESS: "SEARCH_STAFF_SUCCESS",
  SEARCH_STAFF_FAILURE: "SEARCH_STAFF_FAILURE",
  CHANGE_PASSWORD_START: "CHANGE_PASSWORD_START",
  CHANGE_PASSWORD_SUCCESS: "CHANGE_PASSWORD_SUCCESS",
  CHANGE_PASSWORD_FAILURE: "CHANGE_PASSWORD_FAILURE",
  GET_ALL_STAFF_START: "GET_ALL_STAFF_START",
  GET_ALL_STAFF_SUCCESS: "GET_ALL_STAFF_SUCCESS",
  GET_ALL_STAFF_FAILURE: "GET_ALL_STAFF_FAILURE",
  RESET_USER_RESET: "RESET_USER_RESET",
  UPDATE_USER_START: "UPDATE_USER_START",
  UPDATE_USER_SUCCESS: "UPDATE_USER_SUCCESS",
  UPDATE_USER_FAILURE: "UPDATE_USER_FAILURE",
  UPLOAD_DOC_START: "UPLOAD_DOC_START",
  UPLOAD_DOC_SUCCESS: "UPLOAD_DOC_SUCCESS",
  UPLOAD_DOC_FAILURE: "UPLOAD_DOC_FAILURE",
  UPLOAD_DOC_RESET: "UPLOAD_DOC_RESET",
  UPDATE_DOC_START: "UPDATE_DOC_START",
  UPDATE_DOC_SUCCESS: "UPDATE_DOC_SUCCESS",
  UPDATE_DOC_FAILURE: "UPDATE_DOC_FAILURE",
  GET_DOCS_LIST_START: "GET_DOCS_LIST_START",
  GET_DOCS_LIST_SUCCESS: "GET_DOCS_LIST_SUCCESS",
  GET_DOCS_LIST_FAILURE: "GET_DOCS_LIST_FAILURE",
  GET_USER_STATUS_START: "GET_USER_STATUS_START",
  GET_USER_STATUS_SUCCESS: "GET_USER_STATUS_SUCCESS",
  GET_USER_STATUS_FAILURE: "GET_USER_STATUS_FAILURE",
  CLEAR_DOCS_STATE: "CLEAR_DOCS_STATE",
  UPLOAD_POS_DOC_START: "UPLOAD_POS_DOC_START",
  UPLOAD_POS_DOC_SUCCESS: "UPLOAD_POS_DOC_SUCCESS",
  UPLOAD_POS_DOC_FAILURE: "UPLOAD_POS_DOC_FAILURE",
  RENEW_POS_DOC_START: "RENEW_POS_DOC_START",
  RENEW_POS_DOC_SUCCESS: "RENEW_POS_DOC_SUCCESS",
  RENEW_POS_DOC_FAILURE: "RENEW_POS_DOC_FAILURE",
  REGISTER_DEVICE_START: "REGISTER_DEVICE_START",
  REGISTER_DEVICE_SUCCESS: "REGISTER_DEVICE_SUCCESS",
  REGISTER_DEVICE_FAILURE: "REGISTER_DEVICE_FAILURE",
  APPLY_FOR_TEST_CARD_START: "APPLY_FOR_TEST_CARD_START",
  APPLY_FOR_TEST_CARD_SUCCESS: "APPLY_FOR_TEST_CARD_SUCCESS",
  APPLY_FOR_TEST_CARD_FAILURE: "APPLY_FOR_TEST_CARD_FAILURE",
  PAYMENT_START: "PAYMENT_START",
  PAYMENT_SUCCESS: "PAYMENT_SUCCESS",
  PAYMENT_FAILURE: "PAYMENT_FAILURE",
  GET_TEST_CARDS_START: "GET_TEST_CARDS_START",
  GET_TEST_CARDS_SUCCESS: "GET_TEST_CARDS_SUCCESS",
  GET_TEST_CARDS_FAILURE: "GET_TEST_CARDS_FAILURE",
  GET_TESTCARD_PAYMENT_DETAILS_START: "GET_TESTCARD_PAYMENT_DETAILS_START",
  GET_TESTCARD_PAYMENT_DETAILS_SUCCESS: "GET_TESTCARD_PAYMENT_DETAILS_SUCCESS",
  GET_TESTCARD_PAYMENT_DETAILS_FAILURE: "GET_TESTCARD_PAYMENT_DETAILS_FAILURE",
  GET_CERT_PAYMENT_DETAILS_START: "GET_CERT_PAYMENT_DETAILS_START",
  GET_CERT_PAYMENT_DETAILS_SUCCESS: "GET_CERT_PAYMENT_DETAILS_SUCCESS",
  GET_CERT_PAYMENT_DETAILS_FAILURE: "GET_CERT_PAYMENT_DETAILS_FAILURE",
  VERIFY_PAYMENT_START: "VERIFY_PAYMENT_START",
  VERIFY_PAYMENT_SUCCESS: "VERIFY_PAYMENT_SUCCESS",
  VERIFY_PAYMENT_FAILURE: "VERIFY_PAYMENT_FAILURE",
  CLEAR_POS_STATE: "CLEAR_POS_STATE",
  GET_DEMO_SLOT_START: "GET_DEMO_SLOT_START",
  GET_DEMO_SLOT_SUCCESS: "GET_DEMO_SLOT_SUCCESS",
  GET_DEMO_SLOT_FAILURE: "GET_DEMO_SLOT_FAILURE",
  GET_DEMO_MONTHS_START: "GET_DEMO_MONTHS_START",
  GET_DEMO_MONTHS_SUCCESS: "GET_DEMO_MONTHS_SUCCESS",
  GET_DEMO_MONTHS_FAILURE: "GET_DEMO_MONTHS_FAILURE",
  GET_DEMO_DAYS_START: "GET_DEMO_DAYS_START",
  GET_DEMO_DAYS_SUCCESS: "GET_DEMO_DAYS_SUCCESS",
  GET_DEMO_DAYS_FAILURE: "GET_DEMO_DAYS_FAILURE",
  BOOK_SLOT_START: "BOOK_SLOT_START",
  BOOK_SLOT_SUCCESS: "BOOK_SLOT_SUCCESS",
  BOOK_SLOT_FAILURE: "BOOK_SLOT_FAILURE",
  GET_USER_TRAIL_START: "GET_USER_TRAIL_START",
  GET_USER_TRAIL_SUCCESS: "GET_USER_TRAIL_SUCCESS",
  GET_USER_TRAIL_FAILURE: "GET_USER_TRAIL_FAILURE",
  GET_ALL_APPLICATIONS_START: "GET_ALL_APPLICATIONS_START",
  GET_ALL_APPLICATIONS_SUCCESS: "GET_ALL_APPLICATIONS_SUCCESS",
  GET_ALL_APPLICATIONS_FAILURE: "GET_ALL_APPLICATIONS_FAILURE",
  GET_TESTCASE_LOGS_START: "GET_TESTCASE_LOGS_START",
  GET_TESTCASE_LOGS_SUCCESS: "GET_TESTCASE_LOGS_SUCCESS",
  GET_TESTCASE_LOGS_FAILURE: "GET_TESTCASE_LOGS_FAILURE",
  RUN_TEST_START: "RUN_TEST_START",
  RUN_TEST_SUCCESS: "RUN_TEST_SUCCESS",
  RUN_TEST_FAILURE: "RUN_TEST_FAILURE",
  SUBMIT_TEST_RESULTS_START: "SUBMIT_TEST_RESULTS_START",
  SUBMIT_TEST_RESULTS_SUCCESS: "SUBMIT_TEST_RESULTS_SUCCESS",
  SUBMIT_TEST_RESULTS_FAILURE: "SUBMIT_TEST_RESULTS_FAILURE",
  CLEAR_DEMO_STATE: "CLEAR_DEMO_STATE",
  SUBMIT_AGREEMENT_START: "SUBMIT_AGREEMENT_START",
  SUBMIT_AGREEMENT_SUCCESS: "SUBMIT_AGREEMENT_SUCCESS",
  SUBMIT_AGREEMENT_FAILURE: "SUBMIT_AGREEMENT_FAILURE",
  RESET_SUBMIT_AGREEMENT_STATUS: "RESET_SUBMIT_AGREEMENT_STATUS",
  CLEAR_CHECK_STATUS: "CLEAR_CHECK_STATUS",
  CLEAR_VERIFY_EMAIL_STATE: "CLEAR_VERIFY_EMAIL_STATE",
  GET_REQUIRED_DOCS_LIST_START: "GET_REQUIRED_DOCS_LIST_START",
  GET_REQUIRED_DOCS_LIST_SUCCESS: "GET_REQUIRED_DOCS_LIST_SUCCESS",
  GET_REQUIRED_DOCS_LIST_FAILURE: "GET_REQUIRED_DOCS_LIST_FAILURE",
  AUTHENTICATE_USER_START: "AUTHENTICATE_USER_START",
  AUTHENTICATE_USER_SUCCESS: "AUTHENTICATE_USER_SUCCESS",
  AUTHENTICATE_USER_FAILURE: "AUTHENTICATE_USER_FAILURE",
  CLEAR_RESET_PASSWORD_STATE: "CLEAR_RESET_PASSWORD_STATE",
  GET_NAME_ENQUIRY_VALUES_START: "GET_NAME_ENQUIRY_VALUES_START",
  GET_NAME_ENQUIRY_VALUES_SUCCESS: "GET_NAME_ENQUIRY_VALUES_SUCCESS",
  GET_NAME_ENQUIRY_VALUES_FAILURE: "GET_NAME_ENQUIRY_VALUES_FAILURE",
  SEND_NAME_ENQUIRY_VALUES_START: "SEND_NAME_ENQUIRY_VALUES_START",
  SEND_NAME_ENQUIRY_VALUES_SUCCESS: "SEND_NAME_ENQUIRY_VALUES_SUCCESS",
  SEND_NAME_ENQUIRY_VALUES_FAILURE: "SEND_NAME_ENQUIRY_VALUES_FAILURE",
  SEND_FUND_TRANSFER_VALUES_START: "SEND_FUND_TRANSFER_VALUES_START",
  SEND_FUND_TRANSFER_VALUES_SUCCESS: "SEND_FUND_TRANSFER_VALUES_SUCCESS",
  SEND_FUND_TRANSFER_VALUES_FAILURE: "SEND_FUND_TRANSFER_VALUES_FAILURE",
  SEND_STATUS_QUERY_VALUES_START: "SEND_STATUS_QUERY_VALUES_START",
  SEND_STATUS_QUERY_VALUES_SUCCESS: "SEND_STATUS_QUERY_VALUES_SUCCESS",
  SEND_STATUS_QUERY_VALUES_FAILURE: "SEND_STATUS_QUERY_VALUES_FAILURE",
  CLEAR_NIP_INTERACTION_STATE: "CLEAR_NIP_INTERACTION_STATE",
  CLEAR_NIP_SUCCESS_STATE: "CLEAR_NIP_SUCCESS_STATE",
  GET_API_HISTORY_START: "GET_API_HISTORY_START",
  GET_API_HISTORY_SUCCESS: "GET_API_HISTORY_SUCCESS",
  GET_API_HISTORY_FAILURE: "GET_API_HISTORY_FAILURE",
  FILTER_DATE_APIHISTORY_START: "FILTER_DATE_APIHISTORY_START",
  FILTER_DATE_APIHISTORY_SUCCESS: "FILTER_DATE_APIHISTORY_SUCCESS",
  FILTER_DATE_APIHISTORY_FAILURE: "FILTER_DATE_APIHISTORY_FAILURE",
  FILTER_STATUS_APIHISTORY_START: "FILTER_STATUS_APIHISTORY_START",
  FILTER_STATUS_APIHISTORY_SUCCESS: "FILTER_STATUS_APIHISTORY_SUCCESS",
  FILTER_STATUS_APIHISTORY_FAILURE: "FILTER_STATUS_APIHISTORY_FAILURE",
  DOWNLOAD_SDK_STARTS: "DOWNLOAD_SDK_STARTS",
  DOWNLOAD_SDK_SUCCESS: "DOWNLOAD_SDK_SUCCESS",
  DOWNLOAD_SDK_FAILURE: "DOWNLOAD_SDK_FAILURE",
  GET_APPLICATION_HASH_START: "GET_APPLICATION_HASH_START",
  GET_APPLICATION_HASH_SUCCESS: "GET_APPLICATION_HASH_SUCCESS",
  GET_APPLICATION_HASH_FAILURE: "GET_APPLICATION_HASH_FAILURE",
  GET_KONG_ACCESS_TOKEN_START: "GET_KONG_ACCESS_TOKEN_START",
  GET_KONG_ACCESS_TOKEN_FAILURE: "GET_KONG_ACCESS_TOKEN_FAILURE",
  GET_KONG_ACCESS_TOKEN_SUCCESS: "GET_KONG_ACCESS_TOKEN_SUCCESS",
  FETCH_CENTRALPAY_ACCOUNT_START: "FETCH_CENTRALPAY_ACCOUNT_START",
  FETCH_CENTRALPAY_ACCOUNT_SUCCESS: "FETCH_CENTRALPAY_ACCOUNT_SUCCESS",
  FETCH_CENTRALPAY_ACCOUNT_FAILURE: "FETCH_CENTRALPAY_ACCOUNT_FAILURE",
  MAKE_PAYMENT_WITH_BANK_START: "MAKE_PAYMENT_WITH_BANK_START",
  MAKE_PAYMENT_WITH_BANK_SUCCESS: "MAKE_PAYMENT_WITH_BANK_SUCCESS",
  MAKE_PAYMENT_WITH_BANK_FAILURE: "MAKE_PAYMENT_WITH_BANK_FAILURE",
  GET_BANK_NAME_AND_CODE_START: "GET_BANK_NAME_AND_CODE_START",
  GET_BANK_NAME_AND_CODE_SUCCESS: "GET_BANK_NAME_AND_CODE_SUCCESS",
  GET_BANK_NAME_AND_CODE_FAILURE: "GET_BANK_NAME_AND_CODE_FAILURE",
  
  GET_VERIFY_BANK_TRANSFER_START: "GET_VERIFY_BANK_TRANSFER_START",
  GET_VERIFY_BANK_TRANSFER_SUCCESS: "GET_VERIFY_BANK_TRANSFER_SUCCESS",
  GET_VERIFY_BANK_TRANSFER_FAILURE: "GET_VERIFY_BANK_TRANSFER_FAILURE",

  GET_CERTIFICATION_AMOUNT_START: "GET_CERTIFICATION_AMOUNT_START",
  GET_CERTIFICATION_AMOUNT_SUCCESS: "GET_CERTIFICATION_AMOUNT_SUCCESS",
  GET_CERTIFICATION_AMOUNT_FAILURE: "GET_CERTIFICATION_AMOUNT_FAILURE",

  GET_CERTIFICATION_AMOUNT_BY_APPID_START: "GET_CERTIFICATION_AMOUNT_BY_APPID_START",
  GET_CERTIFICATION_AMOUNT_BY_APPID_SUCCESS: "GET_CERTIFICATION_AMOUNT_BY_APPID_SUCCESS",
  GET_CERTIFICATION_AMOUNT_BY_APPID_FAILURE: "GET_CERTIFICATION_AMOUNT_BY_APPID_FAILURE",

GET_APPLICATION_BY_ID_START:"GET_APPLICATION_BY_ID_START",
GET_APPLICATION_BY_ID_SUCCESS: "GET_APPLICATION_BY_ID_SUCCESS",
GET_APPLICATION_BY_ID_FAILURE: "GET_APPLICATION_BY_ID_FAILURE",

UPDATE_POS_DETAILS_START: "UPDATE_POS_DETAILS_START",
UPDATE_POS_DETAILS_SUCCESS: "UPDATE_POS_DETAILS_SUCCESS",
UPDATE_POS_DETAILS_FAILURE: "UPDATE_POS_DETAILS_FAILURE",

  CHECK_TERMINAL_STATUS_START: "CHECK_TERMINAL_STATUS_START",
  CHECK_TERMINAL_STATUS_SUCCESS: "CHECK_TERMINAL_STATUS_SUCCESS",
  CHECK_TERMINAL_STATUS_FAILURE: "CHECK_TERMINAL_STATUS_FAILURE",
  RESET_TERMINAL_START: "RESET_TERMINAL_START",
  RESET_TERMINAL_SUCCESS: "RESET_TERMINAL_SUCCESS",
  RESET_TERMINAL_FAILURE: "RESET_TERMINAL_FAILURE",
  BULK_UNLOCK_TERMINALS_START: "BULK_UNLOCK_TERMINALS_START",
  BULK_UNLOCK_TERMINALS_SUCCESS: "BULK_UNLOCK_TERMINALS_SUCCESS",
  BULK_UNLOCK_TERMINALS_FAILURE: "BULK_UNLOCK_TERMINALS_FAILURE",
  GET_CERTIFICATES_START: "GET_CERTIFICATES_START",
  GET_CERTIFICATES_SUCCESS: "GET_CERTIFICATES_SUCCESS",
  GET_CERTIFICATES_FAILURE: "GET_CERTIFICATES_FAILURE",
  CLEAR_BULK_UNLOCK_RESPONSE: "CLEAR_BULK_UNLOCK_RESPONSE",
  CLEAR_ERROR_RESPONSE: "CLEAR_ERROR_RESPONSE",
  GET_VIOLATION_REASONS_START: "GET_VIOLATION_REASONS_START",
  GET_VIOLATION_REASONS_SUCCESS: "GET_VIOLATION_REASONS_SUCCESS",
  GET_VIOLATION_REASONS_FAILURE: "GET_VIOLATION_REASONS_FAILURE",

};

export default UserActions;
